import { connect } from 'react-redux'

import AddStreamDialog from './AddStreamDialog'
import { fetchCreateStream } from './addStreamDialogActions'

const mapStateToProps = state => ({
  categories: state.topPanel.categories,
  userId: state.authorization.userId
})

const mapDispatchToProps = dispatch => ({
  onSubmit: (userId, streamData) => dispatch(fetchCreateStream(userId, streamData))
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  categories: stateProps.categories,
  onSubmit: (streamData) => dispatchProps.onSubmit({ userId: stateProps.userId, ...streamData }),
  ...ownProps
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AddStreamDialog)
